import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { apiBaseUrls } from '../config/config';

//import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class ReportService {

  private apiBaseUrls: string = apiBaseUrls;
  private token = window.localStorage.getItem('token');

  constructor(private http: HttpClient) { }

  PolicyReportList(formData) {
    let Url = this.apiBaseUrls + `report/listPolicy`

    var header = {
      headers: new HttpHeaders()
        .set('Content-Type', `application/json`)
        .set('Authorization', `${'Bearer: ' + this.token}`)
    }
    return this.http.post(`${Url}`, formData, header);
  }

  PolicyReportList1(formData, id) {
    let Url = this.apiBaseUrls + `report/listPolicy/${id}`
    var header = {
      headers: new HttpHeaders()
        .set('Content-Type', `application/json`)
        .set('Authorization', `${'Bearer: ' + this.token}`)
    }
    return this.http.post(`${Url}`, formData, header);
  }



  PolicyReportList_(formData) {
    let Url_ = this.apiBaseUrls + 'report/listPolicyAgentCode'

    var header = {
      headers: new HttpHeaders()
        .set('Content-Type', `application/json`)
        .set('Authorization', `${'Bearer: ' + this.token}`)
    }
    return this.http.post(`${Url_}`, formData, header);
  }



  PolicyReportList_reject(formData) {
    let Url_ = 'https://bloom-admin-api.redianglobal.comreport/approvePolicy'
    var header = {
      headers: new HttpHeaders()
        .set('Content-Type', `application/json`)
        .set('Authorization', `${'Bearer: ' + this.token}`)
    }
    return this.http.post(`${Url_}`, formData, header);
  }

  PolicyReportList_approve(formData) {
    let Url_ = 'https://bloom-admin-api.redianglobal.comreport/approvePolicy'
    var header = {
      headers: new HttpHeaders()
        .set('Content-Type', `application/json`)
        .set('Authorization', `${'Bearer: ' + this.token}`)
    }
    return this.http.post(`${Url_}`, formData, header);
  }


  ClaimReportList(formData) {
    let Url = this.apiBaseUrls + 'policyClaim/claimpolicyList'
    var header = {
      headers: new HttpHeaders()
        .set('Content-Type', `application/json`)
        .set('Authorization', `${'Bearer: ' + this.token}`)
    }
    return this.http.post(`${Url}`, formData, header);
  }

  ClaimReportList_new(formData) {
    let Url = this.apiBaseUrls + 'policyClaim/claimpolicylistingOld'
    var header = {
      headers: new HttpHeaders()
        .set('Content-Type', `application/json`)
        .set('Authorization', `${'Bearer: ' + this.token}`)
    }
    return this.http.post(`${Url}`, formData, header);
  }

  listPolicy(formData) {
    let Url = this.apiBaseUrls + 'report/listPolicy'
    var header = {
      headers: new HttpHeaders()
        .set('Content-Type', `application/json`)
        .set('Authorization', `${'Bearer: ' + this.token}`)
    }
    return this.http.post(`${Url}`, formData, header);
  }

  

  PolicyTypeList(params: any) {
    const Url = this.apiBaseUrls + 'policy_management/policyCatogaryList';
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.token}`);
    return this.http.get(Url, {
      headers: headers,
      params: params
    });
  }



  ClaimReportstatus(formData: any) {
    const url = `${this.apiBaseUrls}policyClaim/verifyClaim/${formData.policyClaimId}/${formData.status}`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`
    });

    return this.http.post(url, formData, { headers });
  }

  QuoteReportList(formData) {
    let Url = this.apiBaseUrls + 'report/listQuote'
    var header = {
      headers: new HttpHeaders()
        .set('Content-Type', `application/json`)
        .set('Authorization', `${'Bearer: ' + this.token}`)
    }
    return this.http.post(`${Url}`, formData, header);
  }

  TransactionReportList(formData) {
    let Url = this.apiBaseUrls + 'report/listTransaction'
    var header = {
      headers: new HttpHeaders()
        .set('Content-Type', `application/json`)
        .set('Authorization', `${'Bearer: ' + this.token}`)
    }
    return this.http.post(`${Url}`, formData, header);
  }

  CustomerReportList(formData) {
    let Url = this.apiBaseUrls + 'report/listCustomers'
    var header = {
      headers: new HttpHeaders()
        .set('Content-Type', `application/json`)
        .set('Authorization', `${'Bearer: ' + this.token}`)
    }
    return this.http.post(`${Url}`, formData, header);
  }
  CustomerDetailsList(formData, id) {
    let Url = this.apiBaseUrls + `report/listCustomers/${id}`
    var header = {
      headers: new HttpHeaders()
        .set('Content-Type', `application/json`)
        .set('Authorization', `${'Bearer: ' + this.token}`)
    }
    return this.http.post(`${Url}`, formData, header);
  }


  CustomerDetails(data: any) {
    console.log(data, 'service');
    //  let id = 763;

    let page = 1;
    let perpage = 100;
    let Url = this.apiBaseUrls + `report/customerDetails/${data}/${page}/${perpage}`
    var header = {
      headers: new HttpHeaders()
        .set('Content-Type', `application/json`)
        .set('Authorization', `${'Bearer: ' + this.token}`)
    }
    return this.http.get(`${Url}`, header);
  }

  PolicyTotalCount() {
    let Url = this.apiBaseUrls + `dashboard/getLastMonthsCountsForAdmin/lastMonthPolicies`

    var header = {
      headers: new HttpHeaders()
        .set('Content-Type', `application/json`)
        .set('Authorization', `${'Bearer: ' + this.token}`)
    }
    return this.http.get(`${Url}`, header);
  }

  claimRecordCounts() {
    let Url = this.apiBaseUrls + `policyClaim/claimPolicyCount`
    var header = {
      headers: new HttpHeaders()
        .set('Content-Type', `application/json`)
        .set('Authorization', `${'Bearer: ' + this.token}`)
    }
    return this.http.get(`${Url}`, header);
  }


 







  
}
